import { Autocomplete, TextField } from "@mui/material";

export interface TransactionTypeOption {
  Code: string;
  Description: string;
}

const ALL_OPTION: TransactionTypeOption = { Code: "", Description: "All" };

type Props = {
  options: TransactionTypeOption[];
  value: string | null;
  onChange: (value: string | null) => void;
};

export const TransactionTypeFilter = ({ options, value, onChange }: Props) => {
  const items = [ALL_OPTION, ...options];
  const selected = items.find((t) => t.Code === (value ?? "")) ?? ALL_OPTION;

  return (
    <Autocomplete
      options={items}
      getOptionLabel={(option) => option.Description}
      isOptionEqualToValue={(option, val) => option.Code === val.Code}
      value={selected}
      disableClearable
      onChange={(_event, newValue) => {
        const next = newValue ?? ALL_OPTION;
        onChange(next.Code === "" ? null : next.Code);
      }}
      renderInput={(params) => (
        <TextField {...params} label="Type" variant="outlined" fullWidth />
      )}
    />
  );
};
